/**
 * Hotcoin Exchange Metadata
 */

import { HOTCOIN_WS_CHANNELS, HOTCOIN_WS_TOPOLOGY } from './ws';

import type { ExchangeId } from '../../lib/types';

export const HOTCOIN_METADATA = {
  id: 'hotcoin' as ExchangeId,
  restDocs: [
    'https://www.hotcoin.com/en_US/docs/#get-all-trade-pairs',
    'https://www.hotcoin.com/en_US/docs/#get-deep-data',
    'https://www.hotcoin.com/en_US/docs/#get-kline-data',
    'https://www.hotcoin.com/en_US/docs/#real-time-ticker-data',
  ],
  wsDocs: [
    'https://www.hotcoin.com/en_US/docs/#access-instructions-3',
    'https://www.hotcoin.com/en_US/docs/#market-depth-data',
  ],
  wsTopology: HOTCOIN_WS_TOPOLOGY,
  wsChannels: HOTCOIN_WS_CHANNELS,
  notes: [
    'All WebSocket messages are GZIP compressed (like HTX).',
    'Server sends {"ping":"ping"}, client responds {"pong":"pong"} every 5 seconds.',
    'Orderbook sends full snapshots (not incremental updates).',
    'Kline REST API uses seconds (step param), WebSocket uses period format (1m, 5m, etc.).',
  ],
} as const;
